import { colors } from '@/theme/colors';
import { SvgIconCommonProps } from './types/svg-icon-common-props';
export default function EnterDoor({
  className,
  fillPrimary = colors.neutral100,
  fillSecondary = colors.aqua50,
}: SvgIconCommonProps) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="login-3 1" clipPath="url(#clip0_3811_2554)">
        <path
          id="Vector"
          d="M40.5 37.5078V40.5078C40.5 41.3035 40.1839 42.0665 39.6213 42.6291C39.0587 43.1917 38.2956 43.5078 37.5 43.5078H28.5"
          stroke={fillPrimary}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M28.5 7.50781H37.5C38.2956 7.50781 39.0587 7.82388 39.6213 8.38649C40.1839 8.9491 40.5 9.71216 40.5 10.5078V13.5078"
          stroke={fillPrimary}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_3"
          d="M20.788 46.4921L2.788 43.9201C2.43052 43.8695 2.10334 43.6914 1.86668 43.4188C1.63002 43.1461 1.49981 42.7971 1.5 42.4361V7.45007C1.49972 7.10657 1.61734 6.77338 1.83321 6.50618C2.04908 6.23899 2.35011 6.05398 2.686 5.98207L20.686 1.54007C20.9048 1.49323 21.1313 1.49593 21.3489 1.54797C21.5665 1.60001 21.7697 1.70007 21.9436 1.84082C22.1175 1.98157 22.2578 2.15944 22.354 2.36141C22.4503 2.56338 22.5002 2.78433 22.5 3.00807V45.0081C22.4999 45.2229 22.4536 45.4352 22.3643 45.6306C22.275 45.8259 22.1448 45.9999 21.9825 46.1406C21.8202 46.2813 21.6295 46.3855 21.4234 46.4461C21.2174 46.5068 21.0007 46.5224 20.788 46.4921Z"
          stroke={fillPrimary}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_4"
          d="M36 19.5059L30 25.5059H46.5"
          stroke={fillSecondary}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_5"
          d="M36 31.5059L30 25.5059"
          stroke={fillSecondary}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle id="Ellipse" cx="15.75" cy="23.2578" r="1.5" fill="black" />
        <path
          id="Vector_6"
          d="M15.75 23.258C15.6013 23.258 15.456 23.3022 15.3325 23.385C15.209 23.4677 15.1128 23.5854 15.0563 23.7229C14.9998 23.8604 14.9854 24.0116 15.015 24.1573C15.0446 24.303 15.1168 24.4366 15.2225 24.5412C15.3282 24.6457 15.4626 24.7165 15.6086 24.7446C15.7546 24.7726 15.9057 24.7566 16.0426 24.6986C16.1795 24.6406 16.296 24.5432 16.3775 24.4188C16.4589 24.2945 16.5015 24.1487 16.5 24C16.5002 23.9014 16.481 23.8038 16.4434 23.7127C16.4058 23.6216 16.3506 23.5388 16.2809 23.4691C16.2112 23.3994 16.1284 23.3442 16.0373 23.3066C15.9462 23.269 15.8485 23.2497 15.75 23.25"
          stroke={fillPrimary}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3811_2554">
          <rect width="48" height="48" fill={fillPrimary} />
        </clipPath>
      </defs>
    </svg>
  );
}
